import React from 'react';

import { css } from '@emotion/react';
import { Box } from '@opendoor/bricks/core';
import { motion } from 'framer-motion';

import { backdropVariants } from '../menuAnimations';

interface MenuBackdropProps {
  isVisible: boolean;
  onClick: () => void;
}

export const MenuBackdrop: React.FC<MenuBackdropProps> = ({ isVisible, onClick }) => {
  return (
    <Box
      as={motion.div}
      variants={backdropVariants}
      initial="hidden"
      animate={isVisible ? 'visible' : 'hidden'}
      exit="hidden"
      bottom={0}
      position="fixed"
      top={0}
      left={0}
      right={0}
      aria-hidden="true"
      zIndex="0"
      onClick={onClick}
      css={css`
        background-color: rgba(0, 0, 0, 0.2);
      `}
    />
  );
};
